import { blue20opacity15 } from '../../../colors/blue';
import { neutral60opacity10 } from '../../../colors/neutral';
import { rem } from '../../../utils/rem';
export var MuiMenuItem = {
    styleOverrides: {
        root: {
            height: rem(34),
            minHeight: 'auto',
            gap: rem(8),
            '&:hover': {
                backgroundColor: neutral60opacity10,
            },
            '&:active': {
                backgroundColor: blue20opacity15,
            },
            '& [class*=MuiListItemIcon-root]': {
                color: 'inherit',
                minWidth: rem(16), // 16 is from design
            },
            '& [class*=MuiListItemIcon-root]:last-child': {
                marginInlineStart: rem(8),
            },
            '& [class*=MuiListItemIcon-root]:first-of-type': {
                marginInlineStart: rem(0),
            },
            '& [class*=MuiListItemText-inset]': {
                paddingInlineStart: rem(24), // 8px gap and 16px of standard icon size in menu.
            },
        },
    },
};
